export default __webpack_public_path__ + "static/media/2.931b6987.gif";